import { RouteConfig } from "vue-router";
import ContactsComponent from "@/views/contact-us/contact-us.vue";
import { Roles } from "@/types/enums.type";

export default [
  {
    path: "/contacts",
    name: "Contacts",
    component: ContactsComponent,
    meta: {
      roles: [Roles.PracticeUser, Roles.OfficeUser],
      nav: true,
      navTitle: "Contact Us",
      navIcon: "fa-at"
    }
  }
] as RouteConfig[];